import { render, staticRenderFns } from "./ReturnView.vue?vue&type=template&id=d63ea9d8&"
import script from "./ReturnView.vue?vue&type=script&lang=js&"
export * from "./ReturnView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports